<script>
  import { _ } from "svelte-i18n";
  import { createEventDispatcher, onMount, onDestroy } from "svelte";
  import { sharedTimer, sharedTimerMode } from "../../utilities/DataStore";

  export let time = 90;
  let remainingTime = time;
  let countDownTimerObject;
  let countDownTimerText = formatTime(time);
  let lastTimerSeed = null;

  let recordingButtonState = "starting";

  const dispatch = createEventDispatcher();

  function formatTime(time) {
    if (time <= 0) {
      time = 0;
    }
    return Math.floor(time / 60) + ":" + ((time % 60) + "").padStart(2, "0");
  }

  onMount(async () => {
    restartTimer(time);
  });

  $: if (time !== lastTimerSeed) {
    lastTimerSeed = time;
    restartTimer(time);
  }

  onDestroy(() => {
    console.log("the component is being destroyed");

    if (countDownTimerObject) {
      clearInterval(countDownTimerObject);
    }
  });

  function restartTimer(newTime = time) {
    if (countDownTimerObject) {
      clearInterval(countDownTimerObject);
      countDownTimerObject = undefined;
    }

    const parsedTime = Number(newTime);
    remainingTime = Number.isFinite(parsedTime) && parsedTime > 0 ? parsedTime : 0;
    countDownTimerText = formatTime(remainingTime);
    sharedTimer.set(remainingTime);

    if (remainingTime <= 0) {
      return;
    }

    startTimer();
  }

  export function startTimer() {
    if (countDownTimerObject) {
      clearInterval(countDownTimerObject);
    }

    countDownTimerObject = setInterval(function () {
      remainingTime = remainingTime - 1;
      sharedTimer.set(remainingTime);

      if (remainingTime <= 0) {  // Fixed: Changed from < 0 to <= 0
        stopTimer();
        countDownTimerText = "Finished";
      } else {
        countDownTimerText = formatTime(remainingTime);
      }
    }, 1000);
  }

  export function pauseTimer() {
    clearInterval(countDownTimerObject);
    console.log("pauseTimer");

    //disable the pause button, enable the record to allow for new recordings
    recordingButtonState = "record";

    dispatch("counterPause");
  }

  export function resumeTimer() {
    clearInterval(countDownTimerObject);
    console.log("resumeTimer");
    startTimer();
  }

  export function stopTimer() {
    remainingTime = 0;
    countDownTimerText = formatTime(remainingTime);

    clearInterval(countDownTimerObject);
    console.log("stopButton clicked");

    //disable the stop button, enable the record too allow for new recordings
    recordingButtonState = "stop";

    dispatch("counterStop");
  }
</script>

<div class="timer-pill" class:urgent={remainingTime <= 5 && remainingTime > 0}>
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/>
    <polyline points="12 6 12 12 16 14"/>
  </svg>
  <span class="timer-time">{countDownTimerText}</span>
</div>

<style>
  .timer-pill {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    padding: 0.45rem 1.2rem;
    background: #ffffff;
    border: 1.5px solid #e2eaef;
    border-radius: 999px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    color: #64748b;
  }

  .timer-time {
    font-size: 1.1rem;
    font-weight: 700;
    letter-spacing: 0.03em;
    color: #1e293b;
  }

  .urgent .timer-time {
    color: #dc2626;
  }
</style>
